import { render, staticRenderFns } from "./ChamadoConfiguracao.vue?vue&type=template&id=39e4fd2a&scoped=true"
import script from "./ChamadoConfiguracao.vue?vue&type=script&lang=js"
export * from "./ChamadoConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4fd2a",
  null
  
)

export default component.exports